import { render, staticRenderFns } from "./ModalDetalhesColeta.vue?vue&type=template&id=4a945a5f&scoped=true"
import script from "./ModalDetalhesColeta.vue?vue&type=script&lang=js"
export * from "./ModalDetalhesColeta.vue?vue&type=script&lang=js"
import style0 from "./ModalDetalhesColeta.vue?vue&type=style&index=0&id=4a945a5f&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a945a5f",
  null
  
)

export default component.exports